import styles from './ActingResume.module.css';

const ActingResume = () => {
  return (
    <section className={styles.resumeSection}>
      <p className={styles.location}>Member of AEA | Albuquerque, NM</p>
      <p className={styles.representation}>Representation: Bankston Talent Agency</p>

      <div className={styles.section}>
        <h2 className={styles.heading}>Television</h2>
        <ul className={styles.entryList}>
          <li><strong>The Jig is Up</strong> – Candace Rodgers – Alpha Omega Broadcasting</li>
        </ul>
      </div>

      <div className={styles.section}>
        <h2 className={styles.heading}>Film</h2>
        <ul className={styles.entryList}>
          <li><strong>ABQ Brew</strong> – Vanessa – ElDeCa Productions</li>
          <li><strong>Analekta</strong> – Xun – Joel Vallie & Thomas Wilcox</li>
          <li><strong>Racial Bias and Trauma</strong> – Survivor – University of Nevada, Reno</li>
          <li><strong>There’s No One in The Kitchen</strong> – Suzie – Bennie Woodall Productions</li>
        </ul>
      </div>

      <div className={styles.section}>
        <h2 className={styles.heading}>Commercial</h2>
        <ul className={styles.entryList}>
          <li><strong>Super Bowl Vaccine Ad</strong> – Nurse – lavendr.</li>
          <li><strong>LensCrafters</strong> – High Schooler – TapelesFilm</li>
          <li><strong>Stop Trafficking PSA</strong> – Trafficking Victim – New York Film Academy</li>
          <li><strong>DJI</strong> – Proposal Friend 2 – DJI Creative Studio</li>
          <li><strong>Hoag Hospital</strong> – Sierra – Opfer Creative</li>
        </ul>
      </div>

      <div className={styles.section}>
        <h2 className={styles.heading}>Theatre</h2>
        <ul className={styles.entryList}>
          <li><strong>Confinement</strong> – Joy – Fusion Theater</li>
          <li><strong>True Nature of All Being</strong> – Fumiko – Emerson Theater Collaborative</li>
          <li><strong>Young Frankenstein</strong> – Inga – Bannan Theater</li>
        </ul>
      </div>

      <div className={styles.section}>
        <h2 className={styles.heading}>Training</h2>
        <ul className={styles.entryList}>
          <li>Co-Star Bootcamp – Sam Quinn / Southwest Scene Works</li>
          <li>Film Acting and Auditioning – Lora Cunningham / ABQ Actors Studio</li>
          <li>Continuing Actors – Lauren Letherer / Actors Space</li>
        </ul>
      </div>

      <div className={styles.section}>
        <h2 className={styles.heading}>Special Skills</h2>
        <ul className={styles.entryList}>
          <li><strong>Voice:</strong> Mezzo Soprano; Range: E3 – G6</li>
          <li><strong>Instruments:</strong> Piano, Ukulele, Guitar</li>
          <li><strong>Dance:</strong> Hip-Hop, Contemporary</li>
          <li><strong>Languages:</strong> Spanish, French, Cantonese, Mandarin</li>
        </ul>
      </div>
    </section>
  );
};

export default ActingResume;
